var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcBlock16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.343 2.343a8 8 0 1 1 11.314 11.314A8 8 0 0 1 2.343 2.343m.767 2.18a6 6 0 0 0 8.366 8.367zm9.78 6.953A6 6 0 0 0 4.524 3.11z"
})));
export default SvgIcBlock16;